module.exports = __webpack_public_path__ + "img/contact_1.b09413e8.png";